<div class="group3">
    <h4 *ngIf="!hidetitle"> Commerce </h4>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt69 && common.visibleChamp.cltObj69.visible">
        <label class="col-sm-3 champ" style="padding:0px">Contact :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <div *ngIf="!edit && common.visibleChamp.cltObj69.vision"> {{ detail.contact }} </div>
            <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.contact"
                [hidden]="!common.visibleChamp.cltObj69.vision"
                [disabled]="!droit.droitFicheCom || (add && !common.visibleChamp.cltObj69.creation) || (!add && edit && !common.visibleChamp.cltObj69.modifiable)">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt70 && common.visibleChamp.cltObj70.visible">
        <label class="col-sm-3 champ" style="padding:0px">Commercial :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <!--Param 22-->
            <div *ngIf="!edit && common.visibleChamp.cltObj70.vision">
                {{ (detail.userCommercial ? (detail.userCommercial.libelle || detail.userCommercial.nom +
                (detail.userCommercial.prenom ? ' ' + detail.userCommercial.prenom : '')) : 'Tous')
                }}
            </div>
            <div *ngIf="edit">
                <div *ngIf="droit.droitFicheCom && common.visibleChamp.cltObj70.vision"
                    [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj70.creation) || (!add && edit && !common.visibleChamp.cltObj70.modifiable)}">
                    <app-autocomplete (searchfunction)="searchCommercial($event)"
                        (selectfunction)="detail.userCommercial = $event" [results]="listCom" [highlight]="true"
                        [id]="'modedepaie'" [isCombo]="true" [defaultselected]="detail.userCommercial"
                        [defaultsearch]="detail.userCommercial ? (detail.userCommercial.libelle || detail.userCommercial.nom + (detail.userCommercial.prenom ? ' ' + detail.userCommercial.prenom : '')) : 'Tous'"
                        [disablefocus]="true"></app-autocomplete>
                </div>
                <div *ngIf="!droit.droitFicheCom && common.visibleChamp.cltObj70.vision">
                    {{ (detail.userCommercial ? (detail.userCommercial.libelle || detail.userCommercial.nom +
                    (detail.userCommercial.prenom ? ' ' + detail.userCommercial.prenom : '')) : 'Tous')
                    }}
                </div>
            </div>
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt71 && common.visibleChamp.cltObj71.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Commercial 2 :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <!--Param 22-->

            <div *ngIf="!edit && common.visibleChamp.cltObj71.vision">
                {{ (detail.userCommercial2 ? (detail.userCommercial2.libelle || detail.userCommercial2.nom +
                (detail.userCommercial2.prenom ? ' ' + detail.userCommercial2.prenom : '')) : 'Tous')}}
            </div>
            <div *ngIf="edit">
                <div *ngIf="droit.droitFicheCom && common.visibleChamp.cltObj71.vision"
                    [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj71.creation) || (!add && edit && !common.visibleChamp.cltObj71.modifiable)}">
                    <app-autocomplete (searchfunction)="searchCommercial($event)"
                        (selectfunction)="detail.userCommercial2 = $event" [results]="listCom" [highlight]="true"
                        [id]="'modedepaie'" [isCombo]="true" [defaultselected]="detail.userCommercial2"
                        [defaultsearch]="detail.userCommercial2 ? (detail.userCommercial2.libelle || detail.userCommercial2.nom + (detail.userCommercial2.prenom ? ' ' + detail.userCommercial2.prenom : '')) : 'Tous'"
                        [disablefocus]="true"></app-autocomplete>
                </div>
                <div *ngIf="!droit.droitFicheCom && common.visibleChamp.cltObj71.vision">
                    {{ (detail.userCommercial2 ? (detail.userCommercial2.libelle || detail.userCommercial2.nom +
                    (detail.userCommercial2.prenom ? ' ' + detail.userCommercial2.prenom : '')) : 'Tous')}}
                </div>
            </div>
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt72 && common.visibleChamp.cltObj72.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Autre Rep. :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <div *ngIf="!edit && common.visibleChamp.cltObj72.vision"> {{ detail.representant }} </div>
            <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.representant"
                [hidden]="!common.visibleChamp.cltObj72.vision"
                [disabled]="!droit.droitFicheCom || (add && !common.visibleChamp.cltObj72.creation) || (!add && edit && !common.visibleChamp.cltObj72.modifiable)">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt89 && common.visibleChamp.cltObj89.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Site de la société :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" *ngIf="common.visibleChamp.cltObj89.vision" id="checkbox-1-1 "
                class="regular-checkbox regular-checkbox-checked"
                [disabled]=" !edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj89.creation) || (!add && edit && !common.visibleChamp.cltObj89.modifiable)"
                [(ngModel)]="detail.isGroupe" (ngModelChange)="onChangeSiteSociete()">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt90 && common.visibleChamp.cltObj90.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Société du groupe :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" *ngIf="common.visibleChamp.cltObj90.vision" id="checkbox-1-1 "
                class="regular-checkbox regular-checkbox-checked"
                [disabled]=" !edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj90.creation) || (!add && edit && !common.visibleChamp.cltObj90.modifiable) || masqueModificationExterne"
                [(ngModel)]="detail.societeGroupe" (ngModelChange)="onChangeGrpSociete()">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt73 && common.visibleChamp.cltObj73.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Mode de paie. :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <!--global 4-->

            <!-- <div *ngIf="!edit"> {{ typemodepaie }} </div> -->
            <div *ngIf="!edit && common.visibleChamp.cltObj90.vision">
                {{ (modepaie ? (modepaie.libelle || modepaie.libelleObjetEntite
                || typemodepaie) : (typemodepaie || '')) }}
            </div>
            <div *ngIf="edit">
                <div *ngIf="droit.droitFicheCom && common.visibleChamp.cltObj90.vision && !masqueModificationExterne"
                    [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj73.creation) || (!add && edit && !common.visibleChamp.cltObj73.modifiable)}">
                    <app-autocomplete
                        (selectfunction)="detail.modePaie = $event.id; typemodepaie = $event.libelleObjetEntite; modepaie = $event;"
                        [results]="listMode" [highlight]="true" [id]="'modedepaie'" [isCombo]="true"
                        [defaultselected]="modepaie" [disablefocus]="true"
                        [defaultsearch]="modepaie ? modepaie.libelle || modepaie.libelleObjetEntite || typemodepaie : (typemodepaie || '')">
                    </app-autocomplete>
                </div>
                <div *ngIf="(!droit.droitFicheCom || masqueModificationExterne) && common.visibleChamp.cltObj90.vision">
                    {{ (modepaie ? (modepaie.libelle || modepaie.libelleObjetEntite
                    || typemodepaie) : (typemodepaie || '')) }}
                </div>
            </div>
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt81 && common.visibleChamp.cltObj81.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Delai paie. :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <div *ngIf="!edit && common.visibleChamp.cltObj81.vision"> {{ (detail.delaiPaiement || 0) }}
            </div>
            <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.delaiPaiement"
                [hidden]="!common.visibleChamp.cltObj81.vision"
                [disabled]="!droit.droitFicheCom ||  (add && !common.visibleChamp.cltObj81.creation) || (!add && edit && !common.visibleChamp.cltObj81.modifiable) || masqueModificationExterne">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt82 && common.visibleChamp.cltObj82.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Jour paie. :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <div *ngIf="!edit && common.visibleChamp.cltObj82.vision"> {{ (detail.jourPaiement || 0) }}
            </div>
            <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.jourPaiement"
                [hidden]="!common.visibleChamp.cltObj82.vision"
                [disabled]="!droit.droitFicheCom ||  (add && !common.visibleChamp.cltObj82.creation) || (!add && edit && !common.visibleChamp.cltObj82.modifiable) || masqueModificationExterne">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt83 && common.visibleChamp.cltObj83.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Calcul Fin Mois :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" *ngIf="common.visibleChamp.cltObj83.vision" id="checkbox-1-1 "
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom ||  (add && !common.visibleChamp.cltObj83.creation) || (!add && edit && !common.visibleChamp.cltObj83.modifiable) || masqueModificationExterne"
                [(ngModel)]="detail.paiementFinMois">
        </div>
    </div>

    <div class="form-group items col-sm-12"
        *ngIf="societe.conditionPaiementFournisseur && common.visibleChamp.clt83 && common.visibleChamp.cltObj83.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Mode de P.Ach. :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <!--global 4-->

            <!-- <div *ngIf="!edit"> {{ typemodepaie }} </div> -->
            <div *ngIf="!edit && common.visibleChamp.cltObj83.vision">
                {{ (modePaieAchat ? (modePaieAchat.libelle || modePaieAchat.libelleObjetEntite
                || modePaieAchat) : (modePaieAchat || '')) }}
            </div>
            <div *ngIf="edit">
                <div *ngIf="droit.droitFicheCom && common.visibleChamp.cltObj83.vision && !masqueModificationExterne"
                    [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj83.creation) || (!add && edit && !common.visibleChamp.cltObj83.modifiable)}">
                    <app-autocomplete
                        (selectfunction)="detail.modePaieAchat = $event.id; typemodepaieAchat = $event.libelleObjetEntite; modePaieAchat = $event;"
                        [results]="listMode" [highlight]="true" [id]="'modedepaie'" [isCombo]="true"
                        [defaultselected]="modePaieAchat" [disablefocus]="true"
                        [defaultsearch]="modePaieAchat ? modePaieAchat.libelle || modePaieAchat.libelleObjetEntite || typemodepaieAchat : (typemodepaieAchat || '')">
                    </app-autocomplete>
                </div>
                <div *ngIf="(!droit.droitFicheCom || masqueModificationExterne) && common.visibleChamp.cltObj83.vision">
                    {{ (modePaieAchat ? (modePaieAchat.libelle || modePaieAchat.libelleObjetEntite
                    || modePaieAchat) : (modePaieAchat || '')) }}
                </div>
            </div>
        </div>
    </div>

    <div class="form-group items col-sm-12"
        *ngIf="societe.conditionPaiementFournisseur && common.visibleChamp.clt85 && common.visibleChamp.cltObj85.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Jour P .Ach. :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <div *ngIf="!edit && common.visibleChamp.cltObj85.vision"> {{ (detail.jourPaiementAchat || 0) }}
            </div>
            <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.jourPaiementAchat"
                [hidden]="!common.visibleChamp.cltObj85.vision"
                [disabled]="!droit.droitFicheCom ||  (add && !common.visibleChamp.cltObj85.creation) || (!add && edit && !common.visibleChamp.cltObj85.modifiable) || masqueModificationExterne">
        </div>
    </div>

    <div class="form-group items col-sm-12"
        *ngIf=" societe.conditionPaiementFournisseur && common.visibleChamp.clt84 && common.visibleChamp.cltObj84.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Delai P .Ach. :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <div *ngIf="!edit && common.visibleChamp.cltObj82.vision"> {{ (detail.delaiPaiementAchat || 0) }}
            </div>
            <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.delaiPaiementAchat"
                [hidden]="!common.visibleChamp.cltObj84.vision"
                [disabled]="!droit.droitFicheCom ||  (add && !common.visibleChamp.cltObj84.creation) || (!add && edit && !common.visibleChamp.cltObj84.modifiable) || masqueModificationExterne">
        </div>
    </div>

    <div class="form-group items col-sm-12"
        *ngIf="societe.conditionPaiementFournisseur && common.visibleChamp.clt86 && common.visibleChamp.cltObj86.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Calcul Fin Mois Ach. :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" *ngIf="common.visibleChamp.cltObj86.vision" id="checkbox-1-1 "
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom ||  (add && !common.visibleChamp.cltObj86.creation) || (!add && edit && !common.visibleChamp.cltObj86.modifiable) || masqueModificationExterne"
                [(ngModel)]="detail.paiementFinMoisAchat">
        </div>
    </div>

    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt87 && common.visibleChamp.cltObj87.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Code Echéance :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <div *ngIf="!edit && common.visibleChamp.cltObj87.vision"> {{ detail.codeEcheance }} </div>
            <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.codeEcheance"
                [hidden]="!common.visibleChamp.cltObj87.vision"
                [disabled]="!droit.droitFicheCom ||  (add && !common.visibleChamp.cltObj87.creation) || (!add && edit && !common.visibleChamp.cltObj87.modifiable)">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt88 && common.visibleChamp.cltObj88.visible">
        <label class="col-sm-3 champ" style="padding:0px">Code Echéance F. :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <div *ngIf="!edit && common.visibleChamp.cltObj88.vision"> {{ detail.codeEcheanceFacturation }}
            </div>
            <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.codeEcheanceFacturation"
                [hidden]="!common.visibleChamp.cltObj88.vision"
                [disabled]="!droit.droitFicheCom ||  (add && !common.visibleChamp.cltObj88.creation) || (!add && edit && !common.visibleChamp.cltObj88.modifiable)">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt80 && common.visibleChamp.cltObj80.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Encours max. :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <div *ngIf="!edit && common.visibleChamp.cltObj80.vision"> {{ detail.encoursMax }} </div>
            <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.encoursMax"
                [hidden]="!common.visibleChamp.cltObj80.vision"
                [disabled]="!droit.droitFicheCom ||  (add && !common.visibleChamp.cltObj80.creation) || (!add && edit && !common.visibleChamp.cltObj80.modifiable)">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt114 && common.visibleChamp.cltObj114.visible"
        [ngClass]="{'disabledbutton': !common.isModifClient}">
        <label class="col-sm-3 champ" style="padding:0px"> Fact. Auto. :</label>
        <div *ngIf="droit.droitFicheCom && common.visibleChamp.cltObj114.vision"
            class="col-sm-9 champ text-underline historique" style="padding-right: 0px"
            [ngClass]="{'disabledbutton': add || (add && !common.visibleChamp.cltObj114.creation) || (!add && edit && !common.visibleChamp.cltObj114.modifiable)}"
            (click)="showFactAuto()">
            Afficher
        </div>
        <div *ngIf="!droit.droitFicheCom" class="col-sm-9 champ text-underline historique" style="padding-right: 0px">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt129 && common.visibleChamp.cltObj129.visible">
        <label class="col-sm-3 champ" style="padding:0px">Prix Négociés :</label>
        <div *ngIf="droit.droitFicheCom && common.visibleChamp.cltObj129.vision"
            class="col-sm-9 champ text-underline historique" style="padding-right: 0px"
            [ngClass]="{'disabledbutton': add || (add && !common.visibleChamp.cltObj129.creation) || (!add && edit && !common.visibleChamp.cltObj129.modifiable)}"
            (click)="showPrixNego()">
            Afficher
        </div>
        <div *ngIf="!droit.droitFicheCom" class="col-sm-9 champ text-underline historique" style="padding-right: 0px"
            [ngClass]="{'disabledbutton': add || (add && !common.visibleChamp.cltObj129.creation) || (!add && edit && !common.visibleChamp.cltObj129.modifiable)}">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt111 && common.visibleChamp.cltObj111.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Nomenclature Négo. :</label>
        <div *ngIf="droit.droitFicheCom && common.visibleChamp.cltObj111.vision"
            class="col-sm-9 champ text-underline historique" style="padding-right: 0px"
            [ngClass]="{'disabledbutton': !edit || add || (add && !common.visibleChamp.cltObj111.creation) || (!add && edit && !common.visibleChamp.cltObj111.modifiable)}"
            (click)="showNomenclature()">
            Afficher
        </div>
        <div *ngIf="!droit.droitFicheCom" class="col-sm-9 champ text-underline historique" style="padding-right: 0px"
            [ngClass]="{'disabledbutton': !edit || add || (add && !common.visibleChamp.cltObj111.creation) || (!add && edit && !common.visibleChamp.cltObj111.modifiable)}">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt112 && common.visibleChamp.cltObj112.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Libellés Négo. :</label>
        <div *ngIf="droit.droitFicheCom && common.visibleChamp.cltObj112.vision"
            class="col-sm-9 champ text-underline historique" style="padding-right: 0px"
            [ngClass]="{'disabledbutton': !edit || add || (add && !common.visibleChamp.cltObj112.creation) || (!add && edit && !common.visibleChamp.cltObj112.modifiable)}"
            (click)="showLibelleNego()">
            Afficher
        </div>
        <div *ngIf="!droit.droitFicheCom" class="col-sm-9 champ text-underline historique" style="padding-right: 0px"
            [ngClass]="{'disabledbutton': !edit || add || (add && !common.visibleChamp.cltObj112.creation) || (!add && edit && !common.visibleChamp.cltObj112.modifiable)}">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt113 && common.visibleChamp.cltObj113.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Prix Prestations :</label>
        <div *ngIf="droit.droitFicheCom && common.visibleChamp.cltObj113.vision"
            class="col-sm-9 champ text-underline historique" style="padding-right: 0px"
            [ngClass]="{'disabledbutton': add || (add && !common.visibleChamp.cltObj113.creation) || (!add && edit && !common.visibleChamp.cltObj113.modifiable)}"
            (click)="openPrixPrestation()">
            Définir
        </div>
        <div class="col-sm-9 champ text-underline historique" style="padding-right: 0px"></div>
    </div>


    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt75 && common.visibleChamp.cltObj75.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Bennes au for. :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj75.creation) || (!add && edit && !common.visibleChamp.cltObj75.modifiable)"
                [(ngModel)]="detail.isForfait">
        </div>
    </div>


    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt76 && common.visibleChamp.cltObj76.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Bennes à la loc. :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" *ngIf="common.visibleChamp.cltObj76.vision" id="checkbox-1-1 "
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj76.creation) || (!add && edit && !common.visibleChamp.cltObj76.modifiable)"
                [(ngModel)]="detail.isLoc">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt77 && common.visibleChamp.cltObj77.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Location Jour :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" *ngIf="common.visibleChamp.cltObj77.vision" id="checkbox-1-1 "
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj77.creation) || (!add && edit && !common.visibleChamp.cltObj77.modifiable)"
                [(ngModel)]="detail.isLocJournalier">
        </div>
    </div>

    <div class="form-group items col-sm-12"
        *ngIf="societe.gestionLoc1Euro && common.visibleChamp.clt78 && common.visibleChamp.cltObj78.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Loc à 1Euro :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" *ngIf="common.visibleChamp.cltObj78.vision" id="checkbox-1-1 "
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj78.creation) || (!add && edit && !common.visibleChamp.cltObj78.modifiable)"
                [(ngModel)]="detail.loc1Euro">
        </div>
    </div>

    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt79 && common.visibleChamp.cltObj79.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Location Imm. :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" *ngIf="common.visibleChamp.cltObj79.vision" id="checkbox-1-1 "
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj79.creation) || (!add && edit && !common.visibleChamp.cltObj79.modifiable)"
                [(ngModel)]="detail.isLocImmediat">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt107 && common.visibleChamp.cltObj107.visible">
        <label class="col-sm-3 champ" style="padding:0px">Format spe.fact. :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <!--global 37 : if 0 => aucun-->

            <div *ngIf="!edit && common.visibleChamp.cltObj107.vision">
                {{ (detail.formatFactureJRXML ? formspec || 'Aucun' : 'Aucun') }}
            </div>
            <div *ngIf="edit">
                <div *ngIf="droit.droitFicheCom && common.visibleChamp.cltObj107.vision"
                    [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj107.creation) || (!add && edit && !common.visibleChamp.cltObj107.modifiable)}">
                    <app-autocomplete (searchfunction)="searchFactureJRXML($event)"
                        (selectfunction)="detail.formatFactureJRXML = $event.id; modefacturejrxml = $event; formspec = $event.libelleObjetEntite;"
                        [results]="listFormspe" [highlight]="true" [id]="'modedepaie'" [isCombo]="true"
                        [defaultselected]="detail.formatFactureJRXML"
                        [defaultsearch]="modefacturejrxml ? (modefacturejrxml.libelle || formspec) : (formspec || 'Aucun')"
                        [disablefocus]="true"></app-autocomplete>
                </div>
                <div *ngIf="!droit.droitFicheCom && common.visibleChamp.cltObj107.vision">
                    {{ (detail.formatFactureJRXML ? formspec || 'Aucun' : 'Aucun') }}
                </div>
            </div>
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt108 && common.visibleChamp.cltObj108.visible">
        <label class="col-sm-3 champ" style="padding:0px">Nbr. Imp. Fact. :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">

            <div *ngIf="!edit && common.visibleChamp.cltObj108.vision ">
                {{ (detail.nbrFact) }}
            </div>
            <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.nbrFact"
                [hidden]="!common.visibleChamp.cltObj108.vision"
                [disabled]="!droit.droitFicheCom || (add && !common.visibleChamp.cltObj108.creation) || (!add && edit && !common.visibleChamp.cltObj108.modifiable)">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt109 && common.visibleChamp.cltObj109.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Nbr. Imp. Bon :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <div *ngIf="!edit && common.visibleChamp.cltObj109.vision">
                {{ (detail.nbrBon) }}
            </div>
            <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.nbrBon"
                [hidden]="!common.visibleChamp.cltObj109.vision"
                [disabled]="!droit.droitFicheCom || (add && !common.visibleChamp.cltObj109.creation) || (!add && edit && !common.visibleChamp.cltObj109.modifiable)">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt160 && common.visibleChamp.cltObj60.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Nbr. Imp. Bon Ecob. :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <div *ngIf="!edit && common.visibleChamp.cltObj60.vision">
                {{ (detail.nbrBonEcobennes) }}

            </div>
            <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.nbrBonEcobennes"
                [hidden]="!common.visibleChamp.cltObj60.vision"
                [disabled]="!droit.droitFicheCom || (add && !common.visibleChamp.cltObj60.creation) || (!add && edit && !common.visibleChamp.cltObj60.modifiable)">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt110 && common.visibleChamp.cltObj110.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Nbr. Imp. BA. :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <div *ngIf="!edit && common.visibleChamp.cltObj110.vision">
                {{ (detail.nbrBA) }}
            </div>
            <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.nbrBA"
                [hidden]="!common.visibleChamp.cltObj110.vision"
                [disabled]="!droit.droitFicheCom || (add && !common.visibleChamp.cltObj110.creation) || (!add && edit && !common.visibleChamp.cltObj110.modifiable)">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt203 && common.visibleChamp.cltObj203.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Nbr. Imp. BSD. :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <div *ngIf="!edit && common.visibleChamp.cltObj203.vision">
                {{ (detail.nbrImpBSD) }}

            </div>
            <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.nbrImpBSD"
                [hidden]="!common.visibleChamp.cltObj203.vision"
                [disabled]="!droit.droitFicheCom || (add && !common.visibleChamp.cltObj203.creation) || (!add && edit && !common.visibleChamp.cltObj203.modifiable)">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt115 && common.visibleChamp.cltObj115.visible">
        <label class="col-sm-3 champ" style="padding:0px"> CAP au chantier. :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 " *ngIf="common.visibleChamp.cltObj115.vision"
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj115.creation) || (!add && edit && !common.visibleChamp.cltObj115.modifiable)"
                [(ngModel)]="detail.isCapChantier">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt116 && common.visibleChamp.cltObj116.visible">
        <label class="col-sm-3 champ" style="padding:0px"> CAP :</label>
        <div *ngIf="droit.droitFicheCom && common.visibleChamp.cltObj116.vision"
            class="col-sm-9 champ text-underline historique" style="padding-right: 0px"
            [ngClass]="{'disabledbutton': add || (add && !common.visibleChamp.cltObj116.creation) || (!add && edit && !common.visibleChamp.cltObj116.modifiable)}"
            (click)="showCap()">
            Afficher
        </div>
        <div *ngIf="!droit.droitFicheCom" class="col-sm-9 champ text-underline historique" style="padding-right: 0px"
            [ngClass]="{'disabledbutton': add}"></div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt169 && common.visibleChamp.cltObj169.visible">
        <label class="col-sm-3 champ" style="padding:0px"> CAP DND :</label>
        <div *ngIf="droit.droitFicheCom && common.visibleChamp.cltObj169.vision"
            class="col-sm-9 champ text-underline historique" style="padding-right: 0px"
            [ngClass]="{'disabledbutton': add || (add && !common.visibleChamp.cltObj169.creation) || (!add && edit && !common.visibleChamp.cltObj169.modifiable)}"
            (click)="showCapDND()">
            Afficher
        </div>
        <div *ngIf="!droit.droitFicheCom" class="col-sm-9 champ text-underline historique" style="padding-right: 0px"
            [ngClass]="{'disabledbutton': add}"></div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt130 && common.visibleChamp.cltObj130.visible">
        <label class="col-sm-3 champ" style="padding:0px"> CAP Client :</label>
        <div *ngIf="droit.droitFicheCom && common.visibleChamp.cltObj130.vision"
            class="col-sm-9 champ text-underline historique" style="padding-right: 0px"
            [ngClass]="{'disabledbutton': !edit || add || (add && !common.visibleChamp.cltObj130.creation) || (!add && edit && !common.visibleChamp.cltObj130.modifiable)}"
            (click)="showCapClient()">
            Afficher
        </div>
        <div *ngIf="!droit.droitFicheCom" class="col-sm-9 champ text-underline historique" style="padding-right: 0px"
            [ngClass]="{'disabledbutton': !edit}"></div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt165 && common.visibleChamp.cltObj165.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Qté DASRI/mois . :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <!--Global 68 => aucun si 0-->

            <div *ngIf="!edit && common.visibleChamp.cltObj165.vision">
                {{(detail.qteDASRIMois ? (detail.qteDASRIMois.libelle || typeQteDASRI || 'Aucun') : 'Aucun') }}
            </div>

            <div *ngIf="edit">
                <div *ngIf="droit.droitFicheCom && common.visibleChamp.cltObj165.vision"
                    [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj165.creation) || (!add && edit && !common.visibleChamp.cltObj165.modifiable)}">
                    <app-autocomplete (searchfunction)="searchDASRIMois($event)"
                        (selectfunction)="detail.qteDASRIMois = $event;" [results]="listQtedasri" [highlight]="true"
                        [id]="'modedepaie'" [isCombo]="true" [defaultselected]="detail.qteDASRIMois"
                        [defaultsearch]="detail.qteDASRIMois ? (detail.qteDASRIMois.libelle || typeQteDASRI) : 'Aucun'">
                    </app-autocomplete>
                </div>
                <div *ngIf="!droit.droitFicheCom && common.visibleChamp.cltObj165.vision">
                    {{( detail.qteDASRIMois ? (detail.qteDASRIMois.libelle || typeQteDASRI) : 'Aucun') }}
                </div>
            </div>
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt166 && common.visibleChamp.cltObj166.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Code professionnel :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <div *ngIf="!edit && common.visibleChamp.cltObj166.vision">
                {{ detail.codeProfessionnel }}</div>
            <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.codeProfessionnel"
                [hidden]="!common.visibleChamp.cltObj166.vision"
                [disabled]="!droit.droitFicheCom || (add && !common.visibleChamp.cltObj166.creation) || (!add && edit && !common.visibleChamp.cltObj166.modifiable)">
        </div>
    </div>

    <!--
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt91">
        <label class="col-sm-3 champ" style="padding:0px"> Agence de l'eau :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom" [(ngModel)]="detail.isAgenceEau">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt92">
        <label class="col-sm-3 champ" style="padding:0px"> Tx Aide AE (%) :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <div *ngIf="!edit"> {{ detail.txAideAgEau || '25' }} </div>
            <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.txAideAgEau" [disabled]="!droit.droitFicheCom">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt93">
        <label class="col-sm-3 champ" style="padding:0px"> Limite Annuelle AE (T) :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <div *ngIf="!edit"> {{ detail.limiteAideAgEau || '10'}} </div>
            <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.limiteAideAgEau" [disabled]="!droit.droitFicheCom">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt94">
        <label class="col-sm-3 champ" style="padding:0px"> Début Contrat AE :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <div *ngIf="!edit"> {{detail.dateDebutAE !== '01/01/2000'? detail.dateDebutAE : ''}} </div>
            <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.dateDebutAE" (ngModelChange)="common.changeDateFormat('dateDebutAE', detail)" [disabled]="!droit.droitFicheCom">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt95">
        <label class="col-sm-3 champ" style="padding:0px"> Fin Contrat AE :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <div *ngIf="!edit"> {{ detail.dateFinAE !== '31/12/9999' ? detail.dateFinAE : '' }} </div>
            <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.dateFinAE"  (ngModelChange)="common.changeDateFormat('dateFinAE', detail)" [disabled]="!droit.droitFicheCom">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt96">
        <label class="col-sm-3 champ" style="padding:0px"> Elimination des DMS :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom" [(ngModel)]="detail.isDMS">
        </div>
    </div>
    -->

    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt98 && common.visibleChamp.cltObj98.visible">
        <label class="col-sm-3 champ" style="padding:0px"> BSDD N. Chantier :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" *ngIf="common.visibleChamp.cltObj98.vision" id="checkbox-1-1 "
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj98.creation) || (!add && edit && !common.visibleChamp.cltObj98.modifiable)"
                [(ngModel)]="detail.nomChantierBSDD">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt99 && common.visibleChamp.cltObj99.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Forfait déplacement :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" *ngIf="common.visibleChamp.cltObj99.vision" id="checkbox-1-1 "
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj99.creation) || (!add && edit && !common.visibleChamp.cltObj99.modifiable)"
                [(ngModel)]="detail.forfaitDeplacement">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt100 && common.visibleChamp.cltObj100.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Frais de facturation :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" *ngIf="common.visibleChamp.cltObj100.vision" id="checkbox-1-1 "
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj100.creation) || (!add && edit && !common.visibleChamp.cltObj100.modifiable)"
                [(ngModel)]="detail.fraisFacturation">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt131 && common.visibleChamp.cltObj131.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Fact. partielle :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 " *ngIf="common.visibleChamp.cltObj131.vision"
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj131.creation) || (!add && edit && !common.visibleChamp.cltObj131.modifiable)"
                [(ngModel)]="detail.facturationPartielle">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt97 && common.visibleChamp.cltObj97.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Imp. BSD DND :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 " *ngIf="common.visibleChamp.cltObj97.vision"
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj97.creation) || (!add && edit && !common.visibleChamp.cltObj97.modifiable)"
                [(ngModel)]="detail.impBSD">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt101 && common.visibleChamp.cltObj101.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Imp.Recap.Fact. :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 " *ngIf="common.visibleChamp.cltObj101.vision"
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj101.creation) || (!add && edit && !common.visibleChamp.cltObj101.modifiable)"
                [(ngModel)]="detail.imprimeRecapFact">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt132 && common.visibleChamp.cltObj132.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Imp.Recap.Bon Achat :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 " *ngIf="common.visibleChamp.cltObj132.vision"
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj132.creation) || (!add && edit && !common.visibleChamp.cltObj132.modifiable)"
                [(ngModel)]="detail.imprimeRecapBonAchat">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt102 && common.visibleChamp.cltObj102.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Imp.Fact.Tonne :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 " *ngIf="common.visibleChamp.cltObj102.vision"
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj102.creation) || (!add && edit && !common.visibleChamp.cltObj102.modifiable)"
                [(ngModel)]="detail.impFactTonne">
        </div>
    </div>
    <div class="form-group items col-sm-12"
        *ngIf="common.visibleChamp.clt103 && societe.indexationGasoil && common.visibleChamp.cltObj103.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Indexation Gazole :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 " *ngIf="common.visibleChamp.cltObj103.vision"
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj103.creation) || (!add && edit && !common.visibleChamp.cltObj103.modifiable)"
                [(ngModel)]="detail.isIndexationGazole">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt104 && common.visibleChamp.cltObj104.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Imp. Fact+Traite :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 " *ngIf="common.visibleChamp.cltObj104.vision"
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj104.creation) || (!add && edit && !common.visibleChamp.cltObj104.modifiable)"
                [(ngModel)]="detail.impressionFactureAvecTraite">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt105 && common.visibleChamp.cltObj105.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Fact. à part :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 " *ngIf="common.visibleChamp.cltObj105.vision"
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj105.creation) || (!add && edit && !common.visibleChamp.cltObj105.modifiable)"
                [(ngModel)]="detail.isFactAPart">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt106 && common.visibleChamp.cltObj106.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Imp Certif. :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 " *ngIf="common.visibleChamp.cltObj106.vision"
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj106.creation) || (!add && edit && !common.visibleChamp.cltObj106.modifiable)"
                [(ngModel)]="detail.isImpCert">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt117 && common.visibleChamp.cltObj117.visible">
        <label class="col-sm-3 champ" style="padding:0px"> % Escompte :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <!--à formater-->
            <div *ngIf="!edit && common.visibleChamp.cltObj117.vision">
                {{(detail.escompte ? detail.escompte.toFixed(nbdigit) : default.toFixed(nbdigit)) }}
            </div>
            <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.escompte"
                [hidden]="!common.visibleChamp.cltObj117.vision"
                [disabled]="!droit.droitFicheCom || (add && !common.visibleChamp.cltObj117.creation) || (!add && edit && !common.visibleChamp.cltObj117.modifiable)">
        </div>
    </div>

    <div class="form-group items col-sm-12"
        *ngIf="societe.gestionTPP && common.visibleChamp.cltObj156 && common.visibleChamp.cltObj156.visible">
        <label class="col-sm-3 champ" style="padding:0px"> % TPP :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <!--à formater-->
            <div *ngIf="!edit && common.visibleChamp.cltObj156.vision">
                {{(detail.pourcentageTPP ? common.toFixed(detail.pourcentageTPP || 0) : default.toFixed(nbdigit)) }}
            </div>
            <div>
                <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.pourcentageTPP"
                    [hidden]="!common.visibleChamp.cltObj156.vision"
                    [disabled]="!droit.droitFicheCom || (add && !common.visibleChamp.cltObj156.creation) || (!add && edit && !common.visibleChamp.cltObj156.modifiable)">
            </div>
        </div>
    </div>

    <div class="form-group items col-sm-12"
        *ngIf="societe.gestionTPP && common.visibleChamp.cltObj157 && common.visibleChamp.cltObj157.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Libellé TPP :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <!--à formater-->
            <div *ngIf="!edit && common.visibleChamp.cltObj157.vision">
                {{(detail.libelleTPP || '')}}
            </div>
            <div>
                <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.libelleTPP"
                    [hidden]="!common.visibleChamp.cltObj157.vision"
                    [disabled]="!droit.droitFicheCom || (add && !common.visibleChamp.cltObj157.creation) || (!add && edit && !common.visibleChamp.cltObj157.modifiable)">
            </div>
        </div>
    </div>

    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt118 && common.visibleChamp.cltObj118.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Site Prest :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <!--global 0 => aucun-->
            <div *ngIf="!edit && common.visibleChamp.cltObj118.vision">
                {{ (detail.sitePrestation ? (detail.sitePrestation.libelle || detail.sitePrestation.nom || site) : '')
                }}
            </div>
            <div *ngIf="edit">
                <div *ngIf="droit.droitFicheCom && common.visibleChamp.cltObj118.vision"
                    [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj118.creation) || (!add && edit && !common.visibleChamp.cltObj118.modifiable)}">
                    <app-autocomplete (searchfunction)="searchSite($event)"
                        (selectfunction)="detail.sitePrestation = $event;" [results]="listSite" [highlight]="true"
                        [id]="'modedepaie'" [isCombo]="true" [defaultselected]="detail.sitePrestation"
                        [defaultsearch]="detail.sitePrestation ? (detail.sitePrestation.libelle || detail.sitePrestation.nom || site) : '' "
                        [disablefocus]="true">
                    </app-autocomplete>
                </div>
                <div *ngIf="!droit.droitFicheCom && common.visibleChamp.cltObj118.vision">
                    {{ (detail.sitePrestation ? (detail.sitePrestation.libelle || detail.sitePrestation.nom || site) :
                    '') }}
                </div>
            </div>
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt119 && common.visibleChamp.cltObj119.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Site CA :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <!--global 0 => aucun-->

            <div *ngIf="!edit && common.visibleChamp.cltObj119.vision">
                {{ (detail.siteCA ? (detail.siteCA.libelle || detail.siteCA.nom || siteCA) : 'Aucun' ) }}
            </div>
            <div *ngIf="edit">
                <div *ngIf="droit.droitFicheCom && common.visibleChamp.cltObj119.vision"
                    [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj119.creation) || (!add && edit && !common.visibleChamp.cltObj119.modifiable)}">
                    <app-autocomplete (searchfunction)="searchSite($event)" (selectfunction)="detail.siteCA = $event;"
                        [disablefocus]="true" [results]="listSite" [highlight]="true" [id]="'modedepaie'"
                        [isCombo]="true" [defaultselected]="detail.siteCA"
                        [defaultsearch]="detail.siteCA ? (detail.siteCA.libelle || detail.siteCA.nom || siteCA) : 'Aucun'">
                    </app-autocomplete>
                </div>
                <div *ngIf="!droit.droitFicheCom && common.visibleChamp.cltObj119.vision">
                    {{ (detail.siteCA ? (detail.siteCA.libelle || detail.siteCA.nom || siteCA) : 'Aucun' ) }}
                </div>
            </div>
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt120 && common.visibleChamp.cltObj120.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Groupe Imp. :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <!--global 57 => aucun-->

            <div *ngIf="!edit && common.visibleChamp.cltObj120.vision">
                {{(detail.groupeImpression ? (detail.groupeImpression.libelle || groupimp) : 'Aucun') }}
            </div>
            <div *ngIf="edit">
                <div *ngIf="droit.droitFicheCom && common.visibleChamp.cltObj120.vision"
                    [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj120.creation) || (!add && edit && !common.visibleChamp.cltObj120.modifiable)}">
                    <app-autocomplete (searchfunction)="searchGrpImp($event)" (selectfunction)=" selectGrpImpr($event) "
                        [disablefocus]="true" [results]="listGrpimp" [highlight]="true" [id]="'modedepaie'"
                        [isCombo]="true" [defaultselected]="detail.groupeImpression"
                        [defaultsearch]="detail.groupeImpression ? (detail.groupeImpression.libelle || groupimp) : 'Aucun'">
                    </app-autocomplete>
                </div>
                <div *ngIf="!droit.droitFicheCom && common.visibleChamp.cltObj120.vision">
                    {{ (detail.groupeImpression ? (detail.groupeImpression.libelle || groupimp) : 'Aucun') }}
                </div>
            </div>
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt121 && common.visibleChamp.cltObj121.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Client Divers :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" *ngIf="common.visibleChamp.cltObj121.vision" id="checkbox-1-1 "
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj121.creation) || (!add && edit && !common.visibleChamp.cltObj121.modifiable)"
                [(ngModel)]="detail.divers">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt122 && common.visibleChamp.cltObj122.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Affacturage :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 " *ngIf="common.visibleChamp.cltObj122.vision"
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj122.creation) || (!add && edit && !common.visibleChamp.cltObj122.modifiable)"
                [(ngModel)]="detail.affacturage">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt125 && common.visibleChamp.cltObj125.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Démolisseur agréé :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 " *ngIf="common.visibleChamp.cltObj125.vision"
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj125.creation) || (!add && edit && !common.visibleChamp.cltObj125.modifiable)"
                [(ngModel)]="detail.demolisseur">
        </div>
    </div>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt161 && common.visibleChamp.cltObj161.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Num Agrément démolisseur :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <div *ngIf="!edit && common.visibleChamp.cltObj161.vision">
                {{ detail.numAgrementDemolisseur }} </div>
            <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.numAgrementDemolisseur"
                [hidden]="!common.visibleChamp.cltObj161.vision"
                [disabled]="!droit.droitFicheCom || (add && !common.visibleChamp.cltObj161.creation) || (!add && edit && !common.visibleChamp.cltObj161.modifiable)">
        </div>
    </div>
    <div class="form-group items col-sm-12"
        *ngIf="common.visibleChamp.clt123  && common.visibleChamp.cltObj123.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Date facturation :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom" [(ngModel)]="detail.jourFacturationDefini">
            <!--Liste 1 à 31 -->
            <span *ngIf="!edit && common.visibleChamp.cltObj123.vision" style="padding-left: 10px;"> {{
                (detail.jourFacturationDefini ? detail.jourFacturation :
                '') }}</span>
            <div *ngIf="edit" style="margin-top: 5px;">
                <div *ngIf="droit.droitFicheCom && common.visibleChamp.cltObj123.vision"
                    [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj123.creation) || (!add && edit && !common.visibleChamp.cltObj123.modifiable)}">
                    <app-autocomplete (selectfunction)="detail.jourFacturation = $event.libelleObjetEntite;"
                        [results]="listeDate" [highlight]="true" [active]="!detail.jourFacturationDefini"
                        [id]="'modedepaie'" [isCombo]="true" [disablefocus]="true"
                        [defaultselected]="detail.jourFacturation" [defaultsearch]="detail.jourFacturation || ''">
                    </app-autocomplete>
                </div>
                <div *ngIf="!droit.droitFicheCom && common.visibleChamp.cltObj123.vision">
                    {{ (detail.jourFacturation || '') }}
                </div>
            </div>
            <!--input *ngIf="edit" type="text" class="form-control" [disabled]="detail.jourFacturationDefini" style="margin-top: 5px;" [(ngModel)]="detail.jourFacturation" [typeahead]="jours"-->
        </div>
    </div>
    <div class="form-group items col-sm-12"
        *ngIf="common.visibleChamp.clt162  && common.visibleChamp.cltObj162.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Mandat de facturation :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 " *ngIf="common.visibleChamp.cltObj162.vision"
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj162.creation) || (!add && edit && !common.visibleChamp.cltObj162.modifiable)"
                [(ngModel)]="detail.mandatFacturation">
        </div>
    </div>
    <div class="form-group items col-sm-12"
        *ngIf="common.visibleChamp.clt163  && common.visibleChamp.cltObj163.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Date Mandat :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <div *ngIf="!edit && common.visibleChamp.cltObj163.vision">
                {{ (detail.mandatFacturation ? detail.dateMandatFacturation : '') }}
            </div>
            <input *ngIf="edit" type="text" class="form-control" [hidden]="!common.visibleChamp.cltObj163.vision"
                [disabled]="!detail.mandatFacturation || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj163.creation) || (!add && edit && !common.visibleChamp.cltObj163.modifiable)"
                [(ngModel)]="detail.dateMandatFacturation"
                (ngModelChange)="common.changeDateFormat('dateMandatFacturation', detail)">
        </div>
    </div>
    <div class="form-group items col-sm-12"
        *ngIf="common.visibleChamp.clt127  && common.visibleChamp.cltObj127.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Limiter les exutoires :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 " *ngIf="common.visibleChamp.cltObj127.vision"
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj127.creation) || (!add && edit && !common.visibleChamp.cltObj127.modifiable)"
                [(ngModel)]="detail.limiteExutoires">
            <div *ngIf="droit.droitFicheCom && common.visibleChamp.cltObj127.vision"
                class="col-sm-12 champ text-underline historique" style="padding: 0px"
                [ngClass]="{'disabledbutton': !detail.limiteExutoires || !edit || (add && !common.visibleChamp.cltObj127.creation) || (!add && edit && !common.visibleChamp.cltObj127.modifiable)}"
                (click)="showLimiteExu()">
                Afficher
            </div>
            <div *ngIf="!droit.droitFicheCom" class="col-sm-12 champ text-underline historique" style="padding: 0px"
                [ngClass]="{'disabledbutton': !detail.limiteExutoires || !edit}"></div>
        </div>
    </div>
    <div class="form-group items col-sm-12"
        *ngIf="common.visibleChamp.clt164  && common.visibleChamp.cltObj164.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Facture par mail :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 " *ngIf="common.visibleChamp.cltObj164.vision"
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj164.creation) || (!add && edit && !common.visibleChamp.cltObj164.modifiable)"
                [(ngModel)]="detail.factureParMail">
        </div>
    </div>

       <div class="form-group items col-sm-12">
        <label class="col-sm-3 champ" style="padding:0px"> Bon d'achat par mail :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 "
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom"
                [(ngModel)]="detail.isBonAchatParMail">
        </div>
    </div>

    <div class="form-group items col-sm-12"
        *ngIf="common.visibleChamp.clt124  && common.visibleChamp.cltObj124.visible && masqueClientPraxy">
        <label class="col-sm-3 champ" style="padding:0px"> Client PRAXY :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 " *ngIf="common.visibleChamp.cltObj124.vision"
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj124.creation) || (!add && edit && !common.visibleChamp.cltObj124.modifiable)"
                [(ngModel)]="detail.isPraxy">
        </div>
    </div>
    <div class="form-group items col-sm-12"
        *ngIf="common.visibleChamp.clt177  && common.visibleChamp.cltObj177.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Type de flux :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <!-- global 76 -->

            <div *ngIf="!edit && common.visibleChamp.cltObj177.vision"> {{(detail.typeFlux ? (detail.typeFlux.libelle ||
                typeflux) : 'Tous') }} </div>
            <div *ngIf="edit">
                <div *ngIf="droit.droitFicheCom && common.visibleChamp.cltObj177.vision"
                    [ngClass]="{'disabledbutton': (add ) || (!add && edit && !common.visibleChamp.cltObj177.modifiable)}">
                    <app-autocomplete (searchfunction)="searchtypeflux($event)"
                        (selectfunction)="detail.typeFlux = $event;" [disablefocus]="true" [results]="listTypeflux"
                        [highlight]="true" [id]="'modedepaie'" [isCombo]="true" [defaultselected]="detail.typeFlux"
                        [defaultsearch]="detail.typeFlux ? detail.typeFlux.libelle || typeflux : 'Tous'">
                    </app-autocomplete>
                </div>
                <div *ngIf="!droit.droitFicheCom && common.visibleChamp.cltObj177.vision">
                    {{ (detail.typeFlux ? (detail.typeFlux.libelle || typeflux) : 'Tous') }}
                </div>
            </div>
        </div>
    </div>
    <div class="form-group items col-sm-12"
        *ngIf="common.visibleChamp.clt179  && common.visibleChamp.cltObj179.visible">
        <label class="col-sm-3 champ" style="padding:0px"> N° BSD Fact. :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 " *ngIf="common.visibleChamp.cltObj179.vision"
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj179.creation) || (!add && edit && !common.visibleChamp.cltObj179.modifiable)"
                [(ngModel)]="detail.numBSDFacture">
        </div>
    </div>
    <div class="form-group items col-sm-12"
        *ngIf="common.visibleChamp.clt202  && common.visibleChamp.cltObj202.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Info. chantier dans les factures :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 " *ngIf="common.visibleChamp.cltObj202.vision"
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj202.creation) || (!add && edit && !common.visibleChamp.cltObj202.modifiable)"
                [(ngModel)]="detail.infoChantierFacture">
        </div>
    </div>
    <div class="form-group items col-sm-12"
        *ngIf="common.visibleChamp.clt208  && common.visibleChamp.cltObj208.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Chorus Pro :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 " *ngIf="common.visibleChamp.cltObj208.vision"
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj208.creation) || (!add && edit && !common.visibleChamp.cltObj208.modifiable)"
                [(ngModel)]="detail.isChorus" (change)="verifierCodeConfirmation()">
        </div>
    </div>
    <!-- <div class="form-group items col-sm-12"
        *ngIf="common.visibleChamp.clt229  && common.visibleChamp.cltObj229.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Trackdéchets :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 " *ngIf="common.visibleChamp.cltObj229.vision"
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj229.creation) || (!add && edit && !common.visibleChamp.cltObj229.modifiable)"
                [(ngModel)]="detail.isTrackDechet">
        </div>
    </div> -->
    <div class="form-group items col-sm-12"
        *ngIf="common.visibleChamp.clt230  && common.visibleChamp.cltObj230.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Bon chiffrés :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 " *ngIf="common.visibleChamp.cltObj230.vision"
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj230.creation) || (!add && edit && !common.visibleChamp.cltObj230.modifiable)"
                [(ngModel)]="detail.isBonChiffre">
        </div>
    </div>
    <div class="form-group items col-sm-12"
        *ngIf="common.visibleChamp.clt178  && common.visibleChamp.cltObj178.visible">
        <label class="col-sm-3 champ" style="padding:0px"> N Bon Manuel Ob. :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 " *ngIf="common.visibleChamp.cltObj178.vision"
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj178.creation) || (!add && edit && !common.visibleChamp.cltObj178.modifiable)"
                [(ngModel)]="detail.numBonManuelObligatoire">
        </div>
    </div>
    <div class="form-group items col-sm-12"
        *ngIf="common.visibleChamp.clt218  && common.visibleChamp.cltObj218.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Multisite :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 " *ngIf="common.visibleChamp.cltObj218.vision"
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj218.creation) || (!add && edit && !common.visibleChamp.cltObj218.modifiable)"
                [(ngModel)]="detail.isClientMultisite">
        </div>
    </div>
    <div class="form-group items col-sm-12"
        *ngIf="common.visibleChamp.clt224  && common.visibleChamp.cltObj224.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Taux humidité :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 " *ngIf="common.visibleChamp.cltObj224.vision"
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj224.creation) || (!add && edit && !common.visibleChamp.cltObj224.modifiable)"
                [(ngModel)]="detail.isTauxHumidite">
        </div>
    </div>

    <div class="form-group items col-sm-12"
        *ngIf="common.visibleChamp.clt226  && common.visibleChamp.cltObj226.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Attestation 8 flux par chantier :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 " *ngIf="common.visibleChamp.cltObj226.vision"
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj226.creation) || (!add && edit && !common.visibleChamp.cltObj226.modifiable)"
                [(ngModel)]="detail.isAttestation5FluxParChantier">
        </div>
    </div>

    <div class="form-group items col-sm-12"
        *ngIf="common.visibleChamp.clt226  && common.visibleChamp.cltObj226.visible && detail.isAttestation5FluxParChantier">
        <label class="col-sm-3 champ" style="padding:0px"> Attestation 8 flux nom chantier :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 " *ngIf="common.visibleChamp.cltObj226.vision"
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj226.creation) || (!add && edit && !common.visibleChamp.cltObj226.modifiable)"
                [(ngModel)]="detail.attestation7FluxNChantier">
        </div>
    </div>

    <div class="form-group items col-sm-12" *ngIf="societe.gestionDateMax">
        <label class="col-sm-3 champ" style="padding:0px"> Date Max :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <div *ngIf="!edit">
                {{ (detail.dateMax || '') }}
            </div>
            <input *ngIf="edit" type="number" class="form-control" [(ngModel)]="detail.dateMax">
        </div>
    </div>

    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt236 && common.visibleChamp.cltObj236.visible">
        <label class="col-sm-3 champ" style="padding:0px">Catégorie détenteur HU :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <!--Param 22-->
            <div *ngIf="!edit && common.visibleChamp.cltObj70.vision">
                {{ (detail.categorieDetenteurHU ? ((detail.categorieDetenteurHU.code ? detail.categorieDetenteurHU.code
                + '/' : '') + (detail.categorieDetenteurHU.libelle || '')) : 'Aucun') }}
            </div>
            <div *ngIf="edit">
                <div *ngIf="droit.droitFicheCom && common.visibleChamp.cltObj236.vision"
                    [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj236.creation) || (!add && edit && !common.visibleChamp.cltObj236.modifiable)}">
                    <app-autocomplete (selectfunction)="detail.categorieDetenteurHU = $event"
                        [results]="listCategorieDetenteurHU" [highlight]="true" [id]="'modedepaie'" [isCombo]="true"
                        [defaultselected]="detail.categorieDetenteurHU"
                        [defaultsearch]="detail.categorieDetenteurHU ? ((detail.categorieDetenteurHU.code ? detail.categorieDetenteurHU.code + '/' : '') + (detail.categorieDetenteurHU.libelle || '')) : 'Aucun'"
                        [disablefocus]="true"></app-autocomplete>
                </div>
                <div *ngIf="!droit.droitFicheCom && common.visibleChamp.cltObj236.vision">
                    {{ (detail.categorieDetenteurHU ? ((detail.categorieDetenteurHU.code ?
                    detail.categorieDetenteurHU.code + '/' : '') + (detail.categorieDetenteurHU.libelle || '')) :
                    'Aucun')
                    }}
                </div>
            </div>
        </div>
    </div>

    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt237 && common.visibleChamp.cltObj237.visible">
        <label class="col-sm-3 champ" style="padding:0px">Nature tonnages collectés HU :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <!--Param 22-->
            <div *ngIf="!edit && common.visibleChamp.cltObj237.vision">
                {{ (detail.natureTonnageCollecteHU ?((detail.natureTonnageCollecteHU.code ?
                detail.natureTonnageCollecteHU.code + '/' : '') + (detail.natureTonnageCollecteHU.libelle || '')) :
                'Aucun') }}
            </div>
            <div *ngIf="edit">
                <div *ngIf="droit.droitFicheCom && common.visibleChamp.cltObj237.vision"
                    [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj237.creation) || (!add && edit && !common.visibleChamp.cltObj237.modifiable)}">
                    <app-autocomplete (selectfunction)="detail.natureTonnageCollecteHU = $event"
                        [results]="listNatureTonnagesHU" [highlight]="true" [id]="'modedepaie'" [isCombo]="true"
                        [defaultselected]="detail.natureTonnageCollecteHU"
                        [defaultsearch]="detail.natureTonnageCollecteHU ?  ((detail.natureTonnageCollecteHU.code ? detail.natureTonnageCollecteHU.code + '/' : '') + (detail.natureTonnageCollecteHU.libelle || ''))  : 'Aucun'"
                        [disablefocus]="true"></app-autocomplete>
                </div>
                <div *ngIf="!droit.droitFicheCom && common.visibleChamp.cltObj237.vision">
                    {{ (detail.natureTonnagesHU ? ((detail.natureTonnageCollecteHU.code ?
                    detail.natureTonnageCollecteHU.code + '/' : '') + (detail.natureTonnageCollecteHU.libelle || '')) :
                    'Aucun') }}
                </div>
            </div>
        </div>
    </div>

    <div class="form-group items col-sm-12"
        *ngIf="common.visibleChamp.clt238  && common.visibleChamp.cltObj238.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Courtage :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 " *ngIf="common.visibleChamp.cltObj238.vision"
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj238.creation) || (!add && edit && !common.visibleChamp.cltObj238.modifiable)"
                [(ngModel)]="detail.courtage">
        </div>
    </div>

    <div class="form-group items col-sm-12"
        *ngIf="common.visibleChamp.clt239  && common.visibleChamp.cltObj239.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Histo des bons auto :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" id="checkbox-1-1 " *ngIf="common.visibleChamp.cltObj239.vision"
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || !droit.droitFicheCom || (add && !common.visibleChamp.cltObj239.creation) || (!add && edit && !common.visibleChamp.cltObj239.modifiable)"
                [(ngModel)]="detail.histoBonAuto">
        </div>
    </div>

    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt126  && common.visibleChamp.cltObj126.visible"
        [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj126.creation) || (!add && edit && !common.visibleChamp.cltObj126.modifiable)}">
        <div class="champ form-group">Filière de facturation</div>
        <div class="col-sm-12 withchamp">
            <div class="col-sm-12 form-group" *ngFor="let item of listFiliereFact">
                <div class="col-sm-1">
                    <input type="checkbox" id="checkbox-1-1 " *ngIf="common.visibleChamp.cltObj126.vision"
                        class="regular-checkbox regular-checkbox-checked" [disabled]="!edit || !droit.droitFicheCom"
                        [(ngModel)]="item.actif" (ngModelChange)="changeFiliere()">
                </div>
                <div class="col-sm-11">
                    <label class="text" *ngIf="item.valeur && item.valeur !== ''"> {{item.libelle}} </label>
                    <input type="text" class="form-control" [hidden]="!common.visibleChamp.cltObj126.vision"
                        [(ngModel)]="item.valeur" placeholder="{{item.libelle}}"
                        [disabled]="!edit || !item.actif || !droit.droitFicheCom" (ngModelChange)="changeFiliere()" />
                </div>
            </div>
        </div>
    </div>

    <div class=" items col-sm-12" *ngIf="common.visibleChamp.clt133  && common.visibleChamp.cltObj133.visible"
        [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj133.creation) || (!add && edit && !common.visibleChamp.cltObj133.modifiable)}">
        <div class="champ form-group"> Champ Supp. </div>
        <div class="col-sm-12 withchamp">
            <div class="col-sm-12 form-group" *ngFor="let item of listChampSupp">
                <div class="col-sm-1" *ngIf="!item.masque">
                    <input type="checkbox" id="checkbox-1-1 " *ngIf="common.visibleChamp.cltObj133.vision"
                        class="regular-checkbox regular-checkbox-checked" [disabled]="!edit || !droit.droitFicheCom"
                        [(ngModel)]="item.actif">
                </div>
                <div class="col-sm-11" *ngIf="!item.masque">
                    <label class="text" *ngIf="item.valeur && item.valeur !== ''"> {{item.nom}} </label>
                    <input type="number" class="form-control" *ngIf="item.type === 1"
                        [hidden]="!common.visibleChamp.cltObj133.vision" [value]="getValueChampsupp(item.id)"
                        placeholder="{{item.nom}}" [(ngModel)]="item.valeur"
                        [disabled]="!edit || !item.actif || !droit.droitFicheCom" (ngModelChange)="changeFiliere()" />
                    <input type="text" class="form-control" [hidden]="!common.visibleChamp.cltObj133.vision"
                        [(ngModel)]="item.valeur" *ngIf="item.type !== 1 && item.type !== 3"
                        [value]="getValueChampsupp(item.id)" placeholder="{{item.nom}}" [(ngModel)]="item.valeur"
                        [disabled]="!edit || !item.actif || !droit.droitFicheCom" (ngModelChange)="changeFiliere()" />
                    <textarea class="form-control" [(ngModel)]="item.valeur" *ngIf="item.type === 3"
                        [value]="getValueChampsupp(item.id)" placeholder="{{item.nom}}" [(ngModel)]="item.valeur"
                        [disabled]="!edit || !item.actif || !droit.droitFicheCom"
                        (ngModelChange)="changeFiliere()"></textarea>

                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #prixPrestation>
    <div class="modal-header">
        <h4 class="modal-title pull-left"> Tarification des prestations : </h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal();">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body modalFicheClient" style="height: auto">
        <div class="col-sm-12" style="padding: 0px;">
            <div class="form-group items col-sm-12 module" *ngFor="let item of listPrestation">
                <div class="col-sm-6">
                    <mat-checkbox [color]="'primary'" [(ngModel)]="item.checked" (ngModelChange)="revertTarif(item)"
                        [disabled]="!edit"> {{ item.libelle }} : </mat-checkbox>
                </div>
                <div class="col-sm-6 champ" style="padding-right: 0px">
                    <input type="text" class="form-control" [disabled]="!item.checked" [readonly]="!edit"
                        [(ngModel)]="item.tarif">
                </div>
            </div>
        </div>
        <div class="text-right col-sm-12" style="margin-top: 15px; padding: 0px;">
            <button type="button" *ngIf="edit" class=" btn-close btn-valider"
                (click)="saveTarifPrest();common.closeModal();">
                Valider
            </button>
            <button type="button" class=" btn-close" (click)="common.closeModal();"> Annuler </button>
        </div>
    </div>
</ng-template>

<ng-template #confirmationChorus>
    <div class="modal-header">
        <h4 class="modal-title pull-left"> Confirmation client sur Chorus Pro </h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal();">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="height: auto">
        <div class="col-sm-12">
            <div class="col-sm-12" style="padding: 0; text-align: center; height: 50px;">
                <span class="col-sm-12" id="captcha"></span>
            </div>
            <div class="col-sm-12" style="padding: 0">
                <label for="from" class="col-sm-5" style="padding-top: 5px; text-align: center;"> Saisir le code ci
                    dessus : </label>
                <input class="form-control col-sm-7" type="text" [(ngModel)]="cpatchaTextBox" />
            </div>
        </div>
        <div class="text-right col-sm-12" style="margin-top: 15px;">
            <button type="button" class=" btn-close btn-valider" (click)="validationCodeChorus();">
                Valider
            </button>
            <button type="button" class=" btn-close" (click)="revertValeurChorus();common.closeModal();"> Fermer
            </button>
        </div>
    </div>
</ng-template>

<ng-template #msg>
    <div class="modal-body" style="height: auto">
        <div>
            <div class="col-sm-12">
                <label class="cofirmemsg" [innerHTML]="error" style="white-space: pre-line;"> </label>
            </div>
        </div>
        <div class="text-right" style="margin-top: 15px;">
            <button type="button" class=" btn-close btn-mdp" (click)="common.closeModal()">
                Fermer </button>
        </div>
    </div>
</ng-template>